import { FormattedMessage } from 'dibs-react-intl';
import { FC, ReactNode } from 'react';

import styles from './RailItemsContainer.scss';

type Props = {
    items: ReactNode[];
    creatorLink: ReactNode;
};

const RailItemsContainer: FC<Props> = props => {
    const { items, creatorLink } = props;
    return (
        <>
            <div className={styles.wrapper}>
                <span className={styles.label}>
                    <FormattedMessage id="interiorPhoto.rail.shopAll" defaultMessage="Shop All" />{' '}
                    {creatorLink}
                </span>
            </div>
            <div className={styles.tileContainer}>{items}</div>
        </>
    );
};

export default RailItemsContainer;
